export default __webpack_public_path__ + "static/media/Badal_Java_Programming.926b70c3.png";